import { FC, ReactNode } from 'react';

import classNames from 'classnames';

import { Card, useBreakpoint } from '@hh.ru/magritte-ui';

import styles from 'components/common/BannerImg/AiImageGenerationModal/StatusBlock/StatusBlock.module.less';

interface StatusBlockProps {
    content: ReactNode;
    generatedImageLength: number;
}

export const StatusBlock: FC<StatusBlockProps> = ({ content, generatedImageLength }) => {
    const { isMobile } = useBreakpoint();

    return generatedImageLength > 0 ? (
        <div className={styles.statusBlock}>
            <Card padding={isMobile ? 20 : 40} stretched={isMobile}>
                {content}
            </Card>
        </div>
    ) : (
        <div className={classNames(styles.statusBlock, styles.single)}>{content}</div>
    );
};
